<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0016-01-0"><a id="page10"></a><a href="#/contents#fn_9" id="sn_9">DAY 9</a></p>
<p class="ct"><a href="#/contents#fn_9">KNOWING OUR NEEDS—AND MEETING THEM</a></p>
<p class="ext"><span><i>The L<span class="small">ORD</span> God said, “It is not good for the man to be alone. I will make a helper suitable for him.”</i></span></p>
<p class="ext1"><span><i>So the L<span class="small">ORD</span> God caused the man to fall into a deep sleep; and he took one of the man’s ribs. Then the L<span class="small">ORD</span> God made a woman from the rib.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 2:18, 21–22</span></p>
<p class="tx1" id="p0016-04-5"><span class="dcap">D</span>o you have a friend who knows what you need without your having to say a word? What a blessing to be known and loved like that! And God loved Adam that way.</p>
<p class="tx">At God’s instruction, Adam had just done a basic inventory of every animal the Lord had created and given each a name. The last of the menagerie passed by, “but for Adam no suitable helper was found” (Genesis 2:20). Without Adam even voicing the need or desire, and perhaps without Adam even recognizing it on his own, God knew exactly what Adam needed. Our Creator-God was not finished yet!</p>
<p class="tx">God outdid himself in crafting a “helper suitable” for Adam: she took his breath away.</p>
<p class="tx">God knew Adam’s need for companionship and gave him a gift beyond his imagining. Likewise, God knows your needs, and he will meet them—often with a blessing beyond your imagining!</p>
<p class="tx2">THE LORD KNOWS OUR NEEDS AND GENEROUSLY MEETS THEM.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter12.vue?5062d065